import { toFixed } from 'accounting-js';

export default function getOneTimeTotalAmount({
  productType,
  oneTimeSubtotalAmount = 0,
  oneTimeTaxAmount = 0,
  oneTimeTotalAmountExcludingTax = 0,
  oneTimeVariantsAmount = 0,
  setupFeeAmount = 0,
  hasTax = false,
}) {
  if (productType === 'subscription') {
    if (hasTax) {
      return oneTimeTotalAmountExcludingTax + oneTimeTaxAmount;
    } else {
      let totalAmount;

      totalAmount = oneTimeVariantsAmount + setupFeeAmount;

      // return positive amount or zero
      const positiveAmount = Math.max(totalAmount, 0);

      // 0 decimals
      return Number(toFixed(positiveAmount, 0));
    }
  } else {
    let totalAmount;

    totalAmount = oneTimeSubtotalAmount + setupFeeAmount;

    // return positive amount or zero
    const positiveAmount = Math.max(totalAmount, 0);

    // 0 decimals
    return Number(toFixed(positiveAmount, 0));
  }
}
